import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
} from 'react';
import styles from './CommentsModalBody.module.scss';
import ChatComment from '../ChatComment/ChatComment';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import { getDocumentCommentsAction } from '../../../actions/commentsActions/documentsCommentsActions/documentsCommentsActions';

const CommentsModalBody = ({ lightboxConfig }) => {
  const dispatch = useDispatch();
  const scrollDownRef = useRef();
  const commentsContainerRef = useRef();
  const currentUserId = useSelector(
    (state) => state.authentication.userInfo.WorkerId
  );

  const { comments, entityId, page, maxPage } = useSelector(
    (state) => state.commentsChatStore
  );

  const { data, isLoading } = comments;

  const chatComments = useMemo(() => {
    return data?.map((comment) => (
      <ChatComment
        key={comment.noteId || comment.id}
        belongsToCurrentUser={
          currentUserId.toString() === comment.worker?.id.toString() ||
          currentUserId.toString() === comment.user?.id.toString()
        }
        lightboxConfig={lightboxConfig}
        commentData={comment}
      />
    ));
  }, [data]);

  const scrollToBottom = useCallback(() => {
    scrollDownRef.current.scrollIntoView({ behavior: 'auto' });
  }, [entityId]);

  useEffect(() => {
    if (data && page === 0) {
      scrollToBottom(0);
    }
  }, [data, page]);

  const findFirstElementInViewPort = (elements) =>
    Array.prototype.find.call(
      elements,
      (element) => element.getBoundingClientRect().y >= 0 // nav height offset
    );

  const scrollTo = useMemo(() => {
    // Find all elements in container which will be checked if are in view or not
    const nodeElements = commentsContainerRef.current?.querySelectorAll(
      '[comment-data-item]'
    );
    if (nodeElements) {
      return findFirstElementInViewPort(nodeElements);
    }

    return undefined;
  }, [page]);

  useLayoutEffect(() => {
    if (scrollTo && !isLoading) {
      // Scroll to element with should be in view after rendering
      scrollTo.scrollIntoView();
      // Scroll by height of nav
      window.scrollBy(0, 0);
    }
  }, [scrollTo, page, isLoading]);

  const handleScroll = useCallback(
    (e) => {
      if (e.target.scrollTop === 0 && !isLoading) {
        if (page < maxPage) {
          dispatch(getDocumentCommentsAction(entityId, true));
        }
      }
    },
    [entityId, page, maxPage, isLoading]
  );

  return (
    <div
      className={styles.modalBody}
      ref={commentsContainerRef}
      onScroll={handleScroll}
    >
      {chatComments || <div>Комментариев пока нет</div>}
      {isLoading && <Spin />}
      <div style={{ float: 'bottom', clear: 'both' }} ref={scrollDownRef} />
    </div>
  );
};

export default CommentsModalBody;
